import React from 'react';
import type { TRequestsMap } from '../../types';
import RequestsContext from '../context';

type Props = {
  requestsMap: TRequestsMap;
};

const RequestsProvider: Component<Props> = ({ requestsMap, children }) => (
  <RequestsContext.Provider value={{ requestsMap }}>
    {children}
  </RequestsContext.Provider>
);

export default RequestsProvider;
